import {Record, List} from 'immutable';

export function validate(entry) {
  return entry.reasons.some(reason => !reason);
}

export default class CardReasonSchemeEntry extends Record({
  point: null,
  reasons: List(),
}) {
  constructor(object = {}) {
    super(
      Object.assign({}, object, {
        reasons: List(object.reasons || []),
      })
    );
  }
}
